import {
  useQuery,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import * as api from '../api/stock-transfers';

export const useTransfersPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['stock-transfers', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getTransfersPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useTransfer = (uuid) =>
  useQuery({
    queryKey: ['stock-transfers', uuid],
    queryFn: () => api.getTransfer(uuid),
    enabled: !!uuid,
  });

export const useCreateTransfer = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.createTransfer(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stock-transfers'] }),
  });
};

export const useShipTransfer = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.shipTransfer(uuid),
    onSuccess: (_, uuid) => {
      qc.invalidateQueries({ queryKey: ['stock-transfers'] });
      qc.invalidateQueries({ queryKey: ['stock-transfers', uuid] });
    },
  });
};

export const useReceiveTransfer = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ uuid, data }) => api.receiveTransfer(uuid, data),
    onSuccess: (_, { uuid }) => {
      qc.invalidateQueries({ queryKey: ['stock-transfers'] });
      qc.invalidateQueries({ queryKey: ['stock-transfers', uuid] });
      qc.invalidateQueries({ queryKey: ['products'] });
    },
  });
};
